import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import { Constants } from "../../../endPoints";

export default function Homecategory() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(Constants.listCategory);
        const homepageCats = res.data.list.filter(
          // (cat) => cat.is_homepage
          (cat) => cat
        );
        setCategories(homepageCats);
      } catch (err) {
        console.error(err);
      }
    };
    fetchCategories();
  }, []);

console.log(categories)


  return (
    <div className="favouriteSec">
      <div className="container">
        <div className="pagehding txtcenter">
          <strong>Find Your Favourites</strong>
          <h2>
            Add to your <br /> jewellery wardrobe
          </h2>
        </div>

        <div className="favouriteSlder">
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={28}
            loop={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            navigation={{
              nextEl: '.owl-next',
              prevEl: '.owl-prev',
            }}
            breakpoints={{
              0: { slidesPerView: 2 },
              400: { slidesPerView: 2 },
              480: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
              992: { slidesPerView: 5 },
              1200: { slidesPerView: 6 },
              1600: { slidesPerView: 6 },
            }}
          >
            {categories.map((cat) => (
              <SwiperSlide key={cat.id}>
                <div className="item">
                  <div className="favouriteItem">
                    <div className="favouriteimg">
                      <Link to={`/listing?category=${cat.id}`}>
                        <img
                          src={cat.imageWithUrl}
                          alt={cat.name}
                        />
                      </Link>
                    </div>
                    <h3>
                      <Link to={`/listing?category=${cat.id}`}>
                        {cat.name}
                      </Link>
                    </h3>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Owl Style Navigation Buttons */}
          <div class="owl-nav">
            <div class="owl-prev"></div>
            <div class="owl-next"></div>
          </div>
        </div>
      </div>
    </div>
  );
}